import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { formatDate, formatToZMW, handlePrint, rootUrl } from '../../../helpers';
import { useAuth } from '../../../context/auth-context';
import { FaPrint, FaSpinner, FaToggleOff, FaToggleOn } from 'react-icons/fa';

const Receipts = ({startDate, endDate, rdata, triggerFetch}) => {
  const [cashData, setCashData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toggle, setToggle] = useState(false);
  

  const [columnVisibility, setColumnVisibility] = useState({
    accountCode: true,
    accountName: true,
    totalBudget: true,
    flexed: true,
    actual: true,
    actualToDate: true,
    performance: true,
    difference: true,
    budgetPerformance: true,
  });

  const {allData, setAllData} = useOutletContext();
  const auth = useAuth();


  const componentRef = useRef(null)

  function getMonthDifference(startDate, endDate) {
    let start = new Date(startDate);
    let end = new Date(endDate);
    
    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();

    return years * 12 + months;
}

  const accountCodesAndNames = [
    { id: "151", name: "Local taxes/rates" },
    { id: "152", name: "Fees and Charges" },
    { id: "153", name: "Licenses" },
    { id: "154", name: "Levies" },
    { id: "155", name: "Permits" },
    { id: "156", name: "Land Charges" },
    { id: "157", name: "Other Incomes" },
    { id: "158", name: "National Support (Grants)" },
    { id: "159", name: "Donor Support" },
    { id: "111", name: "Total" },
    { id: "1", name: "Constituency Development" },
    { id: "2", name: "Local Governance" },
    { id: "3", name: "Integrated Development Planning" },
    { id: "4", name: "Economic and Business Development" },
    { id: "5", name: "Public Health and Environmental Protection" },
    { id: "6", name: "Housing and Community Amenities" },
    { id: "7", name: "Recreation Culture and Religion" },
    { id: "8", name: "Education and Skills Development" },
    { id: "9", name: "Social Protection" },
    { id: "10", name: "Public Order and Safety" },
    { id: "11", name: "Management and Support Services" },
    { id: "12", name: "Resource Mobilisation and Management" },
    { id: "13", name: "District Health servcies" },
    { id: "14", name: "Veterinary services" },
    { id: "15", name: "Transport Services" },
    { id: "16", name: "Agricultural Services " },
    { id: "17", name: "Fisheries and Livestock" },
    { id: "18", name: "Social Protection and Community Development" },
    { id: "000", name: "Rest" },
  ];
  
  const sumOfArray = (arr) => arr.reduce((acc, num) => acc + num, 0);
  // Fetch data when triggerFetch changes (triggered by button in parent)
  useEffect(() => {
    if (triggerFetch && startDate && endDate) {
      setLoading(true);
      axios
        .get(rootUrl(`/getCashByDate/${auth.user?.cid}~${startDate}~${endDate}`))
        .then((response) => {
          const cash = response.data.data;
          setCashData(cash.cash);
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching data', error);
          setLoading(false);
        });
    }
  }, [triggerFetch]);

  

  function padWithZeros(input) {
  
    const str = input?.toString();
  
    if (str?.length === 1) {
      return "00" + str;
    } else if (str?.length === 2) {
      return "0" + str;
    }
  
    return str;
  }

 

  const renderTableRows = () => {
    const rows = [];
    if(!allData.budget){
        return
    }
    let start = new Date(startDate);
    const yr = start.getFullYear()
    // const accounts = Array.from(
    //   new Map(
    //     allData.budget.map((item) => [`${item.program},${item.subprogram}`, { program: item.program, subprogram: item.subprogram }])
    //   ).values()
    // );

    const accounts = Array.from(
      new Map(
        allData.budget.filter(a=>a.year == yr).map((item) => [
          `${item.program},${item.subprogram}`,
          { program: item.program, subprogram: item.subprogram }
        ])
      ).values()
    ).sort((a, b) => {
      if (a.program === b.program) {
        return a.subprogram - b.subprogram;
      }
      return a.program - b.program;
    });
    
    
    
    let months = getMonthDifference(startDate, endDate) + 1;
    let selectedMonth = new Date(endDate).getMonth()
    
    let totalBudgetg = 0;
    let totalFlexedg = 0;
    let totalActualg = 0;
    let totalActualToDateg = 0;
    let totalDifferenceg = 0;
    
    let counting = 0;

    
    accountCodesAndNames.forEach((account) => {
      let totalBudget = 0;
      let totalBudgets = 0;
      let totalFlexed = 0;
      let totalActual = 0;
      let totalActualToDate = 0;
      let totalFlexedPerformance = 0;
      let totalDifference = 0;
      let totalBuggedPerformance = 0;

      let count = 0
      accounts.forEach((accountCode) => {
        
        if (account.id == accountCode.program) {
          
          const budgetEntries = allData.budget.filter(a=>a.year == yr).filter(item => item.program == accountCode.program && 
            item.subprogram == accountCode.subprogram
          );
          const coaEntries = allData.subProgram.filter(item => item.programCode == accountCode.program && item.subProgramCode == accountCode.subprogram);
          totalBudget = sumOfArray(budgetEntries.map(item => parseFloat(item.price * item.frequency * item.qty)));
          const flexed = (months / 12) * totalBudget;
          const coa = allData.coa.find(item => item.account === accountCode)?.id;
          const actual =  sumOfArray(
            cashData
              ?.filter(item => budgetEntries.some(entry => item.coa_id == entry.id)) 
              .map(item => parseFloat(item.amount))
          );

          const actualOne =  sumOfArray(
            cashData
          ?.filter(item =>
            budgetEntries.some(entry => item.coa_id == entry.id) &&
            new Date(item.date).getMonth() === selectedMonth
          )
          .map(item => parseFloat(item.amount))
          );



          
          if(totalBudget > 0 && !toggle){
           
            rows.push(
                <tr key={`${padWithZeros(accountCode.program)}${padWithZeros(accountCode.subprogram)}`}>
                   {columnVisibility.accountCode && (
              <td className="border border-gray-300 py-2 px-2">{padWithZeros(accountCode.program)}{padWithZeros(accountCode.subprogram)}</td>
                  )}
                   {columnVisibility.accountName && (
              <td className="border border-gray-300 py-2 px-2">{coaEntries[0]?.name}</td>
                  )}
                   {columnVisibility.totalBudget && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudget)}</td>
                  )}
                  {columnVisibility.flexed && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(flexed)}</td>
                  )}
                   {columnVisibility.actual && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(actualOne)}</td>
                  )}
                  {columnVisibility.actualToDate && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(actual)}</td>
                  )}
                   {columnVisibility.performance && (
              <td className="border border-gray-300 py-2 px-2">{((actual / flexed) * 100).toFixed()}%</td>
                  )}
                   {columnVisibility.difference && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudget - actual)}</td>
                  )}
                  {columnVisibility.budgetPerformance && (
              <td className="border border-gray-300 py-2 px-2">{((actual / totalBudget) * 100).toFixed()}%</td>
            )}
                </tr>
              );

              count++;
          }
     
          totalBudgets += totalBudget;
          totalFlexed += flexed;
          totalActual += actualOne;
          totalActualToDate += actual;
          totalFlexedPerformance += (actual / flexed) * 100;
          totalDifference += totalBudget - actual;
          totalBuggedPerformance += (actual / totalBudget) * 100;
        }
      });


      if(totalBudget > 0){
        rows.push(
            <tr key={`${account.id}-total`} className={`${!toggle?'bg-gray-800 text-white':''} m-2 p-2`} >
            {columnVisibility.accountCode && (
            <td className="border border-gray-300 py-2 px-2">{padWithZeros(account.id)}</td>
            )}
            {columnVisibility.accountName && (
            <td className="border border-gray-300 py-2 px-2">{account.name}</td>
            )}
            {columnVisibility.totalBudget && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgets)}</td>
            )}
            {columnVisibility.flexed && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalFlexed)}</td>
            )}
            {columnVisibility.actual && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActual)}</td>
            )}
            {columnVisibility.actualToDate && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualToDate)}</td>
            )}
            {columnVisibility.performance && (
            <td className="border border-gray-300 py-2 px-2">{((totalActualToDate / totalFlexed) * 100).toFixed()}%</td>
            )}
            {columnVisibility.difference && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgets - totalActualToDate)}</td>
            )}
            {columnVisibility.budgetPerformance && (
            <td className="border border-gray-300 py-2 px-2">{((totalActualToDate / totalBudgets) * 100).toFixed()}%</td>
            )}
            </tr>
          );

        }

          
            totalBudgetg += totalBudgets
            totalFlexedg += totalFlexed;
            totalActualg += totalActual;
            totalActualToDateg += totalActualToDate;
            totalDifference += totalBudgetg - totalActualToDateg;
          
          if(account.id == "111"){
            rows.push(
              <tr key={`${account.id}-total`} className={`bg-blue-950 text-white m-2 p-2`} >
              {columnVisibility.accountCode && (
         <td colSpan={2} className='px-2 py-2 border border-gray-200'>{'Total Income'}</td>
             )}
              
              {columnVisibility.totalBudget && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg)}</td>
             )}
             {columnVisibility.flexed && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalFlexedg)}</td>
             )}
              {columnVisibility.actual && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualg)}</td>
             )}
             {columnVisibility.actualToDate && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualToDateg)}</td>
             )}
              {columnVisibility.performance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualToDateg / totalFlexedg) * 100).toFixed()}%</td>
             )}
              {columnVisibility.difference && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg - totalActualToDateg)}</td>
             )}
             {columnVisibility.budgetPerformance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualToDateg / totalBudgetg) * 100).toFixed()}%</td>
       )}
           </tr>
              );
         
              totalBudgetg = 0
              totalFlexedg = 0;
              totalActualg = 0;
              totalActualToDateg = 0;
              totalDifference = 0;
          }

          if(account.id == "000"){
            rows.push(
              <tr key={`${account.id}-total`} className={`bg-blue-950 text-white m-2 p-2`} >
              {columnVisibility.accountCode && (
         <td colSpan={2} className='px-2 py-2 border border-gray-200'>{'Total Expenditure'}</td>
             )}
              
              {columnVisibility.totalBudget && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg)}</td>
             )}
             {columnVisibility.flexed && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalFlexedg)}</td>
             )}
              {columnVisibility.actual && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualg)}</td>
             )}
             {columnVisibility.actualToDate && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualToDateg)}</td>
             )}
              {columnVisibility.performance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualToDateg / totalFlexedg) * 100).toFixed()}%</td>
             )}
              {columnVisibility.difference && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg - totalActualToDateg)}</td>
             )}
             {columnVisibility.budgetPerformance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualToDateg / totalBudgetg) * 100).toFixed()}%</td>
       )}
           </tr>
              );
              totalBudgetg = 0
              totalFlexedg = 0;
              totalActualg = 0;
              totalActualToDateg = 0;
              totalDifference = 0;
          }

    });

    return rows;
  };

  // useEffect(()=>{
  //   renderTableRows()
  // },[toggle])


  const handleColumnToggle = (column) => {
    setColumnVisibility((prev) => ({ ...prev, [column]: !prev[column] }));
  };

  if (loading) {
    return <div className='flex justify-center items-center h-full w-full text-blue-950 text-5xl p-5 m-5 '>
                <FaSpinner size={50} className="spinner"  />
                </div>;
  }

  return (
    <div className="cash-report">
      <h1 className='font-bold text-2xl my-3'>Receipts and Payments By Program</h1>
      
       <button className="bg-blue-950 text-white px-4 py-2 rounded" onClick={()=>setToggle(!toggle)}> 
                 {
                   toggle?<FaToggleOn size={20}/>:<FaToggleOff size={20}/>
                 }
                 </button>
      <div className="my-5 flex flex-wrap gap-4">
  {Object.keys(columnVisibility).map((column) => (
    <label
      key={column}
      className="flex items-center space-x-2 bg-gray-100 px-3 py-2 rounded-md shadow-sm hover:bg-gray-200"
    >
      <input
        type="checkbox"
        checked={columnVisibility[column]}
        onChange={() => handleColumnToggle(column)}
        className="form-checkbox h-4 w-4 text-blue-600 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
      />
      <span className="text-sm text-gray-700">{column}</span>
    </label>
  ))}
</div>


   <button
      onClick={() => handlePrint(componentRef)}
      className="bg-blue-950 text-white px-4 py-2 rounded float-right"
    >
      <FaPrint/>
    </button>

<div ref={componentRef}>

  <div className='text-center'>
              <h2 className='font-bold text-2xl'>{allData.council[0]?.name.toUpperCase()}</h2>
              <h2 className="font-bold text-2xl my-3">{'Receipts and Payments by Programs'.toUpperCase()}</h2>
              <h3 className='text-xl font-bold'>From {formatDate(startDate)} to {formatDate(endDate)}</h3>
          </div>

      <table className="table-auto w-full border-collapse border border-gray-300 rounded-lg">
        <thead>
          
          <tr className='bg-blue-950 text-white'>
            {columnVisibility.accountCode && (
              <th className="border border-gray-300 py-2 px-2">Account Code</th>
            )}
            {columnVisibility.accountName && (
              <th className="border border-gray-300 py-2 px-2">Account Name</th>
            )}
            {columnVisibility.totalBudget && (
              <th className="border border-gray-300 py-2 px-2">Total Budget</th>
            )}
            {columnVisibility.flexed && (
              <th className="border border-gray-300 py-2 px-2">Flexed</th>
            )}
            {columnVisibility.actual && (
              <th className="border border-gray-300 py-2 px-2">Actual</th>
            )}
            {columnVisibility.actualToDate && (
              <th className="border border-gray-300 py-2 px-2">Actual to date</th>
            )}
            {columnVisibility.performance && (
              <th className="border border-gray-300 py-2 px-2">Actual Performance</th>
            )}
            {columnVisibility.difference && (
              <th className="border border-gray-300 py-2 px-2">Difference</th>
            )}
              {columnVisibility.budgetPerformance && (
              <th className="border border-gray-300 py-2 px-2">Budget Performance</th>
            )}
          </tr>
        </thead>
        <tbody>
          {renderTableRows()}
        </tbody>
      </table>
    </div>
    </div>
  );
};

export default Receipts;
